import { defineStore } from "pinia";
import { regionList, availableRegion } from "@/service/global";
import { getGloblRegion } from "@/utils/auth";
export const useRegionStore = defineStore("region", {
    state: () => ({
        region: { label: "", value: 0 },
    }),
    getters: {
        getRegion: (state) => state.region,
    },
    actions: {
        getRegionList() {
            return new Promise((resolve, reject) => {
                regionList()
                    .then((res) => {
                    const results = res.data.map((item) => {
                        return {
                            label: item.region_name,
                            value: item.id
                        };
                    });
                    const contain = results.map((v) => v.value).includes(getGloblRegion().value);
                    this.region = Object.keys(getGloblRegion() || {}).length ? contain ? getGloblRegion() : results[0] : results[0];
                    resolve(results);
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        setRegion(data) {
            this.region = data;
        },
        getAvailableRegion(data) {
            return new Promise((resolve, reject) => {
                availableRegion(data)
                    .then((res) => {
                    resolve(res.data.is_sellable);
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
    }
});
